import { FC, useState } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { SecondaryButton } from "@ucl/library";
import "./SensitiveValueComponent.scss";

export interface SensitiveValueComponentProps {
  hiddenValue?: string;
  children: React.ReactNode;
  className?: string;
}

// TODO: Use an existing UCL Component that does this if it exists, or move this to the UCL.
export const SensitiveValueComponent: FC<SensitiveValueComponentProps> = ({
  children,
  hiddenValue = "••••••••",
  className = "",
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className={`applyforx-sensitive-value ${className}`}>
      <span className="applyforx-sensitive-value__content">
        {isVisible ? children : hiddenValue}
      </span>
      <SecondaryButton
        iconProps={{ icon: isVisible ? faEyeSlash : faEye }}
        onClick={toggleVisibility}
        className="applyforx-sensitive-value__toggle"
        minimal={true}
        cssClass="subtle"
      />
    </div>
  );
};
